import { Link, useLocation } from "react-router-dom";

const COPY = {
  en: {
    tagline: "We get your Munich apartment ready before you move in. Trusted by English-speaking expats relocating to Bavaria.",
    exploreLabel: "Explore",
    exploreItems: [
      { label: "Services", href: "/services" },
      { label: "IKEA Assembly", href: "/ikea-assembly-munich" },
      { label: "FAQ", href: "/faq" },
      { label: "Blog & Insights", href: "/more" },
    ],
    packagesLabel: "Packages",
    pkgItems: ["S — IKEA Assembly", "M — Full Apartment Setup", "L — White Glove Concierge"],
    contactLabel: "Contact",
    rights: "Built for expats, with care.",
    privacyLabel: "Privacy Policy",
    privacyHref: "/privacy",
  },
  de: {
    tagline: "Wir richten Ihre Münchner Wohnung ein, bevor Sie einziehen. Vertraut von englisch- & deutschsprachigen Expats in Bayern.",
    exploreLabel: "Entdecken",
    exploreItems: [
      { label: "Leistungen", href: "/de/leistungen" },
      { label: "IKEA Möbelmontage", href: "/ikea-moebelmontage-muenchen" },
      { label: "FAQ", href: "/de/faq" },
      { label: "Blog & Insights", href: "/de/mehr" },
    ],
    packagesLabel: "Pakete",
    pkgItems: ["S — IKEA Möbelmontage", "M — Komplette Wohnungseinrichtung", "L — White Glove Concierge"],
    contactLabel: "Kontakt",
    rights: "Für Expats, mit Sorgfalt gemacht.",
    privacyLabel: "Datenschutzerklärung",
    privacyHref: "/de/datenschutz",
  },
};

export const SiteFooter = () => {
  const { pathname } = useLocation();
  const isDe = pathname === "/de" || pathname.startsWith("/de/") || pathname === "/ikea-moebelmontage-muenchen";
  const t = COPY[isDe ? "de" : "en"];

  return (
    <footer className="border-t border-[#E5E2DC] bg-[#F5F3EF]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 bg-[#1C3326] flex items-center justify-center text-[#FAF9F6] font-serif text-lg">M</div>
            <span className="font-serif text-xl text-[#1A201C]">MUConcierge</span>
          </div>
          <p className="text-[#5C635A] max-w-md leading-relaxed text-sm">{t.tagline}</p>
        </div>
        <div>
          <p className="tag-line text-[#1C3326] mb-3">{t.exploreLabel}</p>
          <ul className="space-y-2 text-sm text-[#5C635A]">
            {t.exploreItems.map((it) => (
              <li key={it.href}>
                <Link to={it.href} className="hover:text-[#1C3326] transition-colors" data-testid={`footer-link-${it.href}`}>
                  {it.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="tag-line text-[#1C3326] mb-3">{t.packagesLabel}</p>
          <ul className="space-y-2 text-sm text-[#5C635A]">
            {t.pkgItems.map((p) => <li key={p}>{p}</li>)}
          </ul>
        </div>
        <div>
          <p className="tag-line text-[#1C3326] mb-3">{t.contactLabel}</p>
          <ul className="space-y-2 text-sm text-[#5C635A]">
            <li>hello@muconcierge.com</li>
            <li>+49 176 6170 4157</li>
            <li>Schwabing, München</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E2DC] py-5 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-[#5C635A] text-center">
        <span>© {new Date().getFullYear()} MUConcierge. {t.rights}</span>
        <span className="hidden sm:inline opacity-50">·</span>
        <Link
          to={t.privacyHref}
          className="underline underline-offset-4 decoration-[#C26D5C]/40 hover:decoration-[#C26D5C] hover:text-[#1C3326] transition-colors"
          data-testid="footer-privacy-link"
        >
          {t.privacyLabel}
        </Link>
        <span className="hidden sm:inline opacity-50">·</span>
        <a
          href="/muconcierge-service-agreement.pdf"
          target="_blank"
          rel="noopener noreferrer"
          download
          className="inline-flex items-center gap-1.5 underline underline-offset-4 decoration-[#C26D5C]/40 hover:decoration-[#C26D5C] hover:text-[#1C3326] transition-colors"
          data-testid="footer-service-agreement-link"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
          Service Agreement (PDF, EN/DE)
        </a>
      </div>
    </footer>
  );
};
